import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { OPDTestMasterSearchComponent } from './opdtest-master-search/opdtest-master-search.component';
import { Subject } from 'rxjs';
import { BranchMatserService } from '../branch-matser.service';
import { TestModel } from 'app/EMR/PrimaryExaminationModels/test.model';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { HelplistService } from 'app/helplist.service';

@Component({
  selector: 'app-opdtest-master',
  templateUrl: './opdtest-master.component.html',
  styleUrls: ['./opdtest-master.component.scss']
})
export class OPDTestMasterComponent implements OnInit {
  destroytestmaster$: Subject<boolean> = new Subject<boolean>();
  isheader: boolean = false;
  testNameobj: TestModel ={} ;
  private isActive: boolean = true;
  constructor(private helplistservice:HelplistService,private dashboardservice:DashboardService, private dialog: MatDialog, @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
  private dialogRef: MatDialogRef<OPDTestMasterComponent>,private branchMatserService:BranchMatserService) {
    if(data){
      this.isheader =data.isheader;
    }
   }

  ngOnInit(): void {
    this.testNameobj={};
    this.cleardata();
  }
  cleardata(){
    this.testNameobj.pkTestId=0;
    this.testNameobj.isActive=true;
    this.testNameobj.isEdit=false;
    this.testNameobj.testName=null;
  }
  openSearchOPDTestMaster(): void{
    const dialogRef = this.dialog.open(OPDTestMasterSearchComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      // height: "55%",
      width: "50%",
      disableClose: true,
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroytestmaster$)).subscribe(result => {
      if (result != 0) {
        this.testNameobj =result;
      }
    });
  }
  closedialog() {
    this.dialogRef.close();
  }
  saveupdatetestname(event){
   
    let checkdublicatedata=this.helplistservice.tests.filter(item=>item.testName.toLowerCase() ==this.testNameobj.testName.toLowerCase());
    if(checkdublicatedata.length ==0 || this.testNameobj.pkTestId >0){
      const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
      button.setAttribute('disabled', true);
      this.testNameobj.pkTestId=this.testNameobj.pkTestId?this.testNameobj.pkTestId:0;
      this.testNameobj.isEdit =this.testNameobj.pkTestId? true:false;
      
    let payload={
      "OptoTestMaster":this.testNameobj
    }
    this.branchMatserService.insertopdtestname(payload).pipe(takeUntil(this.destroytestmaster$)).subscribe((item:any)=>{
      if(this.testNameobj.pkTestId >0){
        this.dashboardservice.openSnackBar("Record Updated Successfully", "ok");
      }else{
        this.dashboardservice.openSnackBar("Record Saved Successfully", "ok"); 
      }
      this.helplistservice.get_tests();
      this.cleardata();
    },err=>{
      this.cleardata();
      if (err.status == 403) {
        this.dashboardservice.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardservice.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardservice.openSnackBar("API Failed", "OK");
      }
    })
   
  }else{
    this.dashboardservice.openSnackBar("Duplicate data Not Allowed", "ok");  
  }
  }
  ngOnDestroy() {
    this.destroytestmaster$.next(true);
    this.destroytestmaster$.unsubscribe();
    this.testNameobj=null;
  }
}
